export default "__VITE_ASSET__DwN18gnt__"